import { DefaultTagModal } from './default-tag-modal';

export { DefaultTagModal };
